import { RootState } from "../../../utils/types/root-state";

export const getMenuProfileState = (state: RootState) => state.menuProfile;